// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.locationSelectModal__sFoYI {
  width: 720px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
@media (max-width: 810px) {
  .locationSelectModal__sFoYI {
    width: 100%;
    height: 98%;
    max-width: 595px;
  }
}

.modalHead__gDixx {
  min-height: 60px;
  padding: 25px 25px 15px;
  margin-bottom: 0;
  position: relative;
}

.modalHeadTitle__ed5aS {
  color: var(--header-title-main);
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  text-transform: uppercase;
}

.modalCloseBtn__AN2gH {
  stroke: var(--button-surface);
  position: absolute;
  top: 25px;
  right: 25px;
  transition: all 0.3s ease-in-out;
  cursor: pointer;
}

.modalInfoLine__KTGsw {
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 14px;
  text-align: left;
  text-transform: uppercase;
  color: var(--tables-title-text);
  padding: 11px 25px 12px;
  border-top: 1px solid var(--tables-title-stroke);
  border-bottom: 1px solid var(--tables-title-stroke);
  background: var(--tables-title-surface);
}

.modalBody__eOPau {
  height: 100%;
  padding: 25px 25px 0;
  display: flex;
  flex: 1;
  flex-direction: column;
}

.additionaFilters__jXTc9 {
  margin-bottom: 20px;
}

.locationSelectModalDates__L6LIt {
  margin-bottom: 22px;
}

.locationSelectModalFilters__HENxW {
  display: flex;
  gap: 25px;
  align-items: center;
  width: 100%;
}

.datepickerBlock__bd2Lb {
  width: 100%;
  display: flex;
  flex-direction: column;
}
.datepickerBlock__bd2Lb label {
  text-transform: unset;
}

.datepickerRange__WXqbh {
  width: 330px;
  position: relative;
}

.daterangeField__azfzl {
  font-size: 12px;
  width: 100%;
  padding: 11px 16px;
  border: 1px solid var(--button-surface);
  border-radius: 4px;
  cursor: pointer;
}
.daterangeField__azfzl:focus, .daterangeField__azfzl:active {
  border-color: var(--button-surface);
  outline: none;
}
.daterangeField__azfzl:disabled {
  opacity: 0.5;
  border-color: var(--inputs-disable-stroke);
}

.bottomBlock__tKve7 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  height: 36px;
}

.daterangeFieldCalendarIcon__EDs8L {
  position: absolute;
  bottom: 3px;
  right: 15px;
  transform: translateY(-50%);
}

.disabledIcon__dlHwz {
  opacity: 0.5;
}

.containsListButtons__isnfq,
.fileFormatSwitcher__s1jS0 {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.fileFormatSwitcher__s1jS0 {
  width: 100%;
}

.fileFormatWrapper__syI7U {
  width: 48%;
}

.modalFooter__ft_Lp {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 25px;
  padding: 25px;
}

.fullHeight__DVdWY .facilitiesBlockFull {
  max-height: 1000px;
}
.fullHeight__DVdWY .checkableTreeBlockFull {
  max-height: 400px;
}
.fullHeight__DVdWY .scrollBlockFull {
  max-height: 400px;
}
.fullHeight__DVdWY .empty-locations-block {
  max-height: 470px;
}`, "",{"version":3,"sources":["webpack://./../src/components/modals/LocationSelectModal/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AAzEF;AA2EE;EANF;IAOI,WAAA;IACA,WAAA;IACA,gBAAA;EAxEF;AACF;;AA2EA;EACE,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;AAxEF;;AA2EA;EA5BE,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AA3CF;;AAsEA;EACE,6BAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,gCAAA;EACA,eAAA;AAnEF;;AAsEA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,+BAAA;EACA,uBAAA;EACA,gDAAA;EACA,mDAAA;EACA,uCAAA;AAnEF;;AAsEA;EACE,YAAA;EACA,oBAAA;EACA,aAAA;EACA,OAAA;EACA,sBAAA;AAnEF;;AAsEA;EACE,mBAAA;AAnEF;;AAsEA;EACE,mBAAA;AAnEF;;AAsEA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,WAAA;AAnEF;;AAsEA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;AAnEF;AAqEE;EACE,qBAAA;AAnEJ;;AAuEA;EACE,YAAA;EACA,kBAAA;AApEF;;AAuEA;EACE,eAAA;EACA,WAAA;EACA,kBAAA;EACA,uCAAA;EACA,kBAAA;EACA,eAAA;AApEF;AAsEE;EAEE,mCAAA;EACA,aAAA;AArEJ;AAwEE;EACE,YAAA;EACA,0CAAA;AAtEJ;;AA0EA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;AAvEF;;AA0EA;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,2BAAA;AAvEF;;AA0EA;EACE,YAAA;AAvEF;;AA0EA;;EAEE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AAvEF;;AA0EA;EACE,WAAA;AAvEF;;AA0EA;EACE,UAAA;AAvEF;;AA0EA;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;AAvEF;;AA4EI;EACE,kBAAA;AAzEN;AA4EI;EACE,iBAAA;AA1EN;AA6EI;EACE,iBAAA;AA3EN;AA8EI;EACE,iBAAA;AA5EN","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.locationSelectModal {\n  width: 720px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n\n  @media (max-width: 810px) {\n    width: 100%;\n    height: 98%;\n    max-width: 595px;\n  }\n}\n\n.modalHead {\n  min-height: 60px;\n  padding: 25px 25px 15px;\n  margin-bottom: 0;\n  position: relative;\n}\n\n.modalHeadTitle {\n  @include modalTitle;\n}\n\n.modalCloseBtn {\n  stroke: var(--button-surface);\n  position: absolute;\n  top: 25px;\n  right: 25px;\n  transition: all 0.3s ease-in-out;\n  cursor: pointer;\n}\n\n.modalInfoLine {\n  font-size: 12px;\n  font-weight: 400;\n  letter-spacing: 0;\n  line-height: 14px;\n  text-align: left;\n  text-transform: uppercase;\n  color: var(--tables-title-text);\n  padding: 11px 25px 12px;\n  border-top: 1px solid var(--tables-title-stroke);\n  border-bottom: 1px solid var(--tables-title-stroke);\n  background: var(--tables-title-surface);\n}\n\n.modalBody {\n  height: 100%;\n  padding: 25px 25px 0;\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n}\n\n.additionaFilters {\n  margin-bottom: 20px;\n}\n\n.locationSelectModalDates {\n  margin-bottom: 22px;\n}\n\n.locationSelectModalFilters {\n  display: flex;\n  gap: 25px;\n  align-items: center;\n  width: 100%;\n}\n\n.datepickerBlock {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n\n  label {\n    text-transform: unset;\n  }\n}\n\n.datepickerRange {\n  width: 330px;\n  position: relative; \n}\n\n.daterangeField {\n  font-size: 12px;\n  width: 100%;\n  padding: 11px 16px;\n  border: 1px solid var(--button-surface);\n  border-radius: 4px;\n  cursor: pointer;\n\n  &:focus,\n  &:active {\n    border-color: var(--button-surface);\n    outline: none;\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    border-color: var(--inputs-disable-stroke);\n  }\n}\n\n.bottomBlock {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 10px;\n  height: 36px;\n}\n\n.daterangeFieldCalendarIcon {\n  position: absolute;\n  bottom: 3px;\n  right: 15px;\n  transform: translateY(-50%);\n}\n\n.disabledIcon {\n  opacity: 0.5;\n}\n\n.containsListButtons,\n.fileFormatSwitcher {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.fileFormatSwitcher {\n  width: 100%\n}\n\n.fileFormatWrapper {\n  width: 48%;\n}\n\n.modalFooter {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 25px;\n  padding: 25px;\n}\n\n.fullHeight {\n  :global {\n    .facilitiesBlockFull {\n      max-height: 1000px;\n    }\n\n    .checkableTreeBlockFull {\n      max-height: 400px;\n    }\n\n    .scrollBlockFull {\n      max-height: 400px;\n    }\n\n    .empty-locations-block {\n      max-height: 470px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"locationSelectModal": `locationSelectModal__sFoYI`,
	"modalHead": `modalHead__gDixx`,
	"modalHeadTitle": `modalHeadTitle__ed5aS`,
	"modalCloseBtn": `modalCloseBtn__AN2gH`,
	"modalInfoLine": `modalInfoLine__KTGsw`,
	"modalBody": `modalBody__eOPau`,
	"additionaFilters": `additionaFilters__jXTc9`,
	"locationSelectModalDates": `locationSelectModalDates__L6LIt`,
	"locationSelectModalFilters": `locationSelectModalFilters__HENxW`,
	"datepickerBlock": `datepickerBlock__bd2Lb`,
	"datepickerRange": `datepickerRange__WXqbh`,
	"daterangeField": `daterangeField__azfzl`,
	"bottomBlock": `bottomBlock__tKve7`,
	"daterangeFieldCalendarIcon": `daterangeFieldCalendarIcon__EDs8L`,
	"disabledIcon": `disabledIcon__dlHwz`,
	"containsListButtons": `containsListButtons__isnfq`,
	"fileFormatSwitcher": `fileFormatSwitcher__s1jS0`,
	"fileFormatWrapper": `fileFormatWrapper__syI7U`,
	"modalFooter": `modalFooter__ft_Lp`,
	"fullHeight": `fullHeight__DVdWY`
};
module.exports = ___CSS_LOADER_EXPORT___;
